<nav class="navs">
  <ul class="nav nav-underline nav-client-type" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link" [ngClass]="{ 'active': activeTab === 'resource' }" id="resource-tab" data-bs-toggle="tab" data-bs-target="#resource" type="button" role="tab"
        aria-controls="resource" aria-selected="activeTab === 'resource'" (click)="setActiveTab('resource')">{{'SCHEDULE_BOOKING' | translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" [ngClass]="{ 'active': activeTab === 'projects' }" id="projects-tab" data-bs-toggle="tab" data-bs-target="#projects" type="button" role="tab"
        aria-controls="projects" aria-selected="activeTab === 'projects'" (click)="setActiveTab('projects')">{{'APPOINTMENT_SCHEDULED' | translate}}</button>
    </li>

    <li class="nav-item" role="presentation">
      <button class="nav-link" [ngClass]="{ 'active': activeTab === 'blocked' }" id="blocked-tab" data-bs-toggle="tab" data-bs-target="#blocked" type="button" role="tab"
        aria-controls="blocked" aria-selected="activeTab === 'blocked'" (click)="setActiveTab('blocked')">Bloqueos</button>
  </ul>
</nav>

<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="resource" role="tabpanel" aria-labelledby="resource-tab" *ngIf="activeTab === 'resource'">
    <div *ngIf="getListingAppointments()">
      <app-timekit-bookings></app-timekit-bookings>
    </div>
  </div>

  <div class="tab-pane fade show active" id="projects" role="tabpanel" aria-labelledby="projects-tab" *ngIf="activeTab === 'projects'">
    <div *ngIf="getListingCreateAppointment()">
      <app-timekit-reschedule></app-timekit-reschedule>
    </div>
  </div>

  <div class="tab-pane fade show active" id="blocked" role="tabpanel" aria-labelledby="blocked-tab" *ngIf="activeTab === 'blocked'">
    <div *ngIf="getListingBlockedSlots()">
      <app-blocked-slots-table></app-blocked-slots-table>
    </div>
  </div>
</div>
<app-footer></app-footer>
